import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBecepsLeftArm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBecepsLeftArm"><Path d="M13.1689 2C9.49998 2 9.99943 7.99944 13.999 7C16.4989 10.9999 14.6318 12 16 15C14.6696 13.8596 13.1988 13.0201 11.6729 13.0312C8.99906 8.00025 1.9974 9.67814 2 14.9502C2.00012 23.7105 16.5908 23.1583 21.668 19.4707C23.3218 10.0703 18.5302 2.00035 13.1689 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBecepsLeftArm;
